import { formatPrice, formatPriceRange } from '~/js/utils/products-and-collections';

const computePrice = (variants, field, ignoreZeros) => {
  if (variants.length === 0) {
    return '\u200b';
  }

  if (variants.length === 1) {
    const price = variants[0][field];
    if (!price) return '';
    return formatPrice(price, ignoreZeros);
  }

  const minPrice = Math.min(...variants.map((variant) => Number(variant[field]?.amount)));
  const maxPrice = Math.max(...variants.map((variant) => Number(variant[field]?.amount)));
  const currencyCode = variants[0][field]?.currencyCode;
  if (isNaN(minPrice) || isNaN(maxPrice)) return '';
  if (!currencyCode) return '';

  return formatPriceRange({ amount: minPrice, currencyCode }, { amount: maxPrice, currencyCode }, ignoreZeros);
};

const heroProductInfo = () => ({
  get price() {
    return computePrice(this.parentSelectedVariants, 'price', false);
  },

  get priceRegular() {
    return computePrice(this.parentSelectedVariants, 'compareAtPrice', true);
  },

  get hasReducedPrice() {
    const { priceRegular, price } = this;
    return priceRegular && priceRegular !== price;
  },

  get pricingText() {
    return `reduced price: ${this.price}, regular price: ${this.priceRegular}`;
  },

  init() {},
});

export default heroProductInfo;
